module.exports = __webpack_public_path__ + "static/media/tacometro-alto-grande.59da6849.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/tacometro-alto-grande.svg
// module id = 157
// module chunks = 0